var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWhiteCloseIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.716105 9.28405C0.769424 9.33737 0.839105 9.36396 0.908924 9.36396C0.978742 9.36396 1.04856 9.33737 1.10174 9.28405L4.99983 5.38596L8.89792 9.28405C8.95124 9.33737 9.02092 9.36396 9.09074 9.36396C9.16056 9.36396 9.23038 9.33737 9.28356 9.28405C9.39006 9.17755 9.39006 9.00491 9.28356 8.89841L5.38547 5.00032L9.28356 1.10223C9.39006 0.99573 9.39006 0.823094 9.28356 0.716594C9.17706 0.610094 9.00442 0.610094 8.89792 0.716594L4.99983 4.61468L1.10174 0.716594C0.995242 0.610094 0.822605 0.610094 0.716105 0.716594C0.609605 0.823094 0.609605 0.99573 0.716105 1.10223L4.6142 5.00032L0.716105 8.89841C0.609605 9.00491 0.609605 9.17755 0.716105 9.28405Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.716105 9.28405C0.769424 9.33737 0.839105 9.36396 0.908924 9.36396C0.978742 9.36396 1.04856 9.33737 1.10174 9.28405L4.99983 5.38596L8.89792 9.28405C8.95124 9.33737 9.02092 9.36396 9.09074 9.36396C9.16056 9.36396 9.23038 9.33737 9.28356 9.28405C9.39006 9.17755 9.39006 9.00491 9.28356 8.89841L5.38547 5.00032L9.28356 1.10223C9.39006 0.99573 9.39006 0.823094 9.28356 0.716594C9.17706 0.610094 9.00442 0.610094 8.89792 0.716594L4.99983 4.61468L1.10174 0.716594C0.995242 0.610094 0.822605 0.610094 0.716105 0.716594C0.609605 0.823094 0.609605 0.99573 0.716105 1.10223L4.6142 5.00032L0.716105 8.89841C0.609605 9.00491 0.609605 9.17755 0.716105 9.28405",
    stroke: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWhiteCloseIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/WhiteCloseIcon.b6eb5acda4712bcb0f54a495b8e1f21c.svg";